<template>
  <div v-show="info.status === 'edit'" class="edit-box">
    <a-switch
        v-model:checked="data[propName]"
        :checked-children="widget.trueText"
        :un-checked-children="widget.falseText"
    />
  </div>
  <div v-show="info.status === 'show'" class="view-box">
    <toggle-table :data="data" v-bind="$props"/>
  </div>
</template>

<script lang="ts" setup>
import {defineProps, watch} from 'vue';
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer"
import {ScForm} from "@/models/ScForm";
import ToggleTable from "./ToggleTable.vue";
import {ToggleFieldType} from "@/components/business/crud/interface/FieldType";

const props = defineProps<{
  propName: string;
  widget: ToggleFieldType;
  info: WidgetInfo;
}>();

const data = ScForm.useFormData();
watch(data, () => {
  if (data.value[props.propName] === undefined) {
    data.value[props.propName] = false;
  }
}, {immediate: true})

</script>


<style lang="scss" scoped>
.edit-box {
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.view-box {
  height: 100%;
  padding-left: 12px;
}
</style>
